import { render, staticRenderFns } from "./CardEditConfig.vue?vue&type=template&id=71b8faaa&scoped=true&"
import script from "./CardEditConfig.vue?vue&type=script&lang=js&"
export * from "./CardEditConfig.vue?vue&type=script&lang=js&"
import style0 from "./CardEditConfig.vue?vue&type=style&index=0&id=71b8faaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8faaa",
  null
  
)

export default component.exports